// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/help-desk',

  component: () => import('modules/helpDesk/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'HelpDesk',
            name: 'HelpDesk'
          }
        ]
      },
      name: 'HelpDesk',
      component: () => import('modules/helpDesk/GridDash.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.helpdesk.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'hdc-integracao',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'HelpDesk',
            name: 'HelpDesk'
          },
          {
            text: 'HDC Integração',
            name: 'HDCIntegracao'
          }
        ]
      },
      name: 'HDCIntegracao',
      component: () => import('modules/powerbi/HDCIntegracao'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.hdc_integracao.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'operacao-ams-tim',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'HelpDesk',
            name: 'HelpDesk'
          },
          {
            text: 'OperaçãoAMS TIM',
            name: 'OperacaoAMSTIM'
          }
        ]
      },
      name: 'OperacaoAMSTIM',
      component: () => import('modules/powerbi/OperacaoAMSTIM'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.operacao_ams_tim.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'solicitacao-acesso',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'HelpDesk',
            name: 'HelpDesk'
          },
          {
            text: 'Solicitação de Acesso',
            name: 'AccessRequests'
          }
        ]
      },
      name: 'AccessRequests',
      component: () => import('modules/powerbi/AccessRequests'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.accessrequests')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
